/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';

// Possible offer shipping strings
var SEE_STORE_FOR_SHIPPING = "See Store for Shipping";
var FREE_SHIPPING = "Free Shipping";

/**
 * Creates an online offers section
 *
 * <online-offers
 *     data-online-offers-sorted-by-price="ProductCtrl.onlineOffers">
 * </online-offers>
 *
 * Today online offers object example:
 * {
 *     total_price: 1,298
 *     price: 1,298
 *     shipping: Free Shipping
 *     store_name: Sears
 *     link: http://www.jdoqocy.com/click-5623602-11515703?url=http://www.sears.com/p/p-02646092000P
 *     store_logo:  //s3.enervee.com/media/offerlogos/sears400.png
 * }
 *
 */
function onlineOffersDirective() {
    return {
        restrict: 'E',
        scope: {
            onlineOffersSortedByPrice: '=',
            productDetailData: '='
        },
        controller: onlineOffersController,
        template: require('./onlineOffersView.html')
    };
}

onlineOffersController.$inject = [
    '$scope',
    '$window',
    '$rootScope',
    'AnalyticsService',
    'ProductService',
    'CmsContentService',
    'UtilService',
];
function onlineOffersController (
    $scope,
    $window,
    $rootScope,
    AnalyticsService,
    ProductService,
    CmsContentService,
    UtilService
) {

    this.$onInit = function () {
        var vm = this;
        var freeDeliveryText = "",
            seeStoreForShippingText = "";

        $scope.categoryId = $scope.productDetailData.category.id;

        $scope.getShipping = function (offerShipping) {

            if (offerShipping === SEE_STORE_FOR_SHIPPING) {
                return seeStoreForShippingText;
            } else if (offerShipping === FREE_SHIPPING) {
                return freeDeliveryText;
            } else {
                return UtilService.getSetting('currencySign') + offerShipping;
            }
        };

        $scope.redirectToRetailer = ProductService.redirectToRetailer;

        CmsContentService.getMarketPlaceText('offers:free_delivery').then(function (text) {
            freeDeliveryText = text;
        });
        CmsContentService.getMarketPlaceText('offers:see_store_for_shipping').then(function (text) {
            seeStoreForShippingText = text;
        });
        CmsContentService.getMarketPlaceText('offers:buy').then(function (text) {
            $scope.buyBtnText = text;
        });
        CmsContentService.getMarketPlaceText('offers:seller').then(function (text) {
            $scope.sellerText = text;
        });
        CmsContentService.getMarketPlaceText('offers:delivery').then(function (text) {
            $scope.deliveryText = text;
        });
        CmsContentService.getMarketPlaceText('offers:full_price').then(function (text) {
            $scope.fullPriceText = text;
        });
        CmsContentService.getMarketPlaceText('offers:visit_store').then(function (text) {
            $scope.visitStoreText = text;
        });

        /**
         * Popovers
         */
        $scope.sponsoredOfferPopoverIsEnabled = true;
        $scope.sponsoredOfferPopoverIsOpen = false;

        $scope.sponsoredOfferPopover = {
            templateUrl: '/common_utils/popovers/sponsoredOfferPopover.html'
        };
        $scope.context = {make: $scope.productDetailData.make};

        $scope.generalOfferPopoverIsEnabled = true;
        $scope.generalOfferPopoverIsOpen = false;

        $scope.generalOfferPopover = {
            templateUrl: '/common_utils/popovers/generalOfferPopover.html'
        };

        // cloudinary image loading support
        $scope.onlineOffersSortedByPrice.forEach(function (offer, count) {
            offer.offerImageId = "Offer" + count;
        });

        /**
         * Tracking
         */
        $scope.trackOffersViewed = function () {
            $scope.onlineOffersSortedByPrice.forEach(function (offer, index) {
                var offerDetails = ProductService.getOfferTrackingDetails(offer);
                offerDetails.position = index + 1;
                offerDetails.product_ids = [$scope.productDetailData.id];
                AnalyticsService.reportEvent('Offer Viewed', offerDetails, $scope.productDetailData);
            });
        };
    }
}

module.exports = onlineOffersDirective;
